// Kinds
export const AUDIO = 'audio'
export const DOCUMENT = 'document'
export const IMAGE = 'image'
export const VIDEO = 'video'
export const VIDEO_LINK = 'videoLink'

// Sizes - see fv-be/firstvoices/firstvoices/settings.py
export const ORIGINAL = 'original'
export const SMALL = 'small'
export const MEDIUM = 'medium'
export const THUMBNAIL = 'thumbnail'

// Supported Extensions
export const SUPPORTED_AUDIO_EXTENSIONS = ['wav', 'mp3', 'oga', 'opus', 'weba']
export const SUPPORTED_DOCUMENT_EXTENSIONS = ['pdf', 'csv', 'txt', 'rtf']
export const SUPPORTED_IMAGE_EXTENSIONS = [
  'jpeg',
  'jpg',
  'png',
  'gif',
  'tiff',
  'tif',
]
export const SUPPORTED_VIDEO_EXTENSIONS = ['mp4', 'mov']
export const SUPPORTED_IMPORT_MEDIA_EXTENSIONS = [
  ...SUPPORTED_AUDIO_EXTENSIONS,
  ...SUPPORTED_DOCUMENT_EXTENSIONS,
  ...SUPPORTED_IMAGE_EXTENSIONS,
  ...SUPPORTED_VIDEO_EXTENSIONS,
]
